export default __webpack_public_path__ + "static/media/buttons-card-4.44adb5b5.svg";